<template>
  <div class="module-title">
    <span>——</span>
    <span class="logo">
      <img :src="logoSrc" alt="Logo" />
    </span>
    <span class="title-text">{{ title }}</span>
    <span>——</span>
  </div>
</template>

<script>
  export default {
    name: 'ModuleTitle',
    props: {
      title: {
        type: String,
        required: true,
        default: '服务行业12大领域'
      },
      logoSrc: {
        type: String,
        default: require('@/assets/image/index/index-logo.png')
      }
    }
  }
</script>

<style scoped>
  .module-title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    color: #009173;
    text-align: center;
    margin: 2vw 0;
    font-weight: bold;
  }

  .module-title span {
    margin: 0 0.5vw;
    /* margin-left: 0.5vw; */
  }

  .module-title .logo img {
    width: 3vw;
    height: auto;
  }

  .module-title .title-text {
    font-weight: bold;
    font-size: 1.5rem;
    /* color: #333; */
  }

  .title-text {
    margin-left: 0.5vw;
  }

  @media (max-width: 768px) {

    .module-title .logo img {
      width: 38px;
    }

  }
</style>
